// Field schema for each CMS resource
export const RESOURCE_CONFIG = {
  courses: {
    label: "Programs / Courses",
    addLabel: "Add Course",
    list: (item) => ({
      title: item.name,
      subtitle: `${item.category?.toUpperCase()} · ${item.duration}`,
      image: item.image,
      badges: [
        item.actual_fee ? `₹${item.actual_fee}` : null,
        item.discounted_fee ? `₹${item.discounted_fee}` : null,
      ].filter(Boolean),
      published: item.published,
    }),
    fields: [
      { key: "name", label: "Course Name *", type: "text", required: true },
      {
        key: "category",
        label: "Category *",
        type: "select",
        required: true,
        options: [
          { value: "subjective", label: "Subjective Coaching" },
          { value: "ai-computer", label: "AI-Powered Computer Education" },
          { value: "short", label: "Short-term" },
          { value: "professional", label: "Professional" },
          { value: "highered", label: "Higher Education" },
        ],
      },
      { key: "duration", label: "Duration *", type: "text", placeholder: "e.g. 6 Months", required: true },
      { key: "image", label: "Cover Image", type: "image" },
      { key: "outcomes", label: "Outcomes / short bullets (one per line)", type: "list" },
      { key: "skills", label: "Skills / Curriculum (one per line, AI-Computer only)", type: "list" },
      { key: "careers", label: "Career Opportunities (one per line, AI-Computer only)", type: "list" },
      { key: "registration_fee", label: "Registration Fee (₹, AI-Computer only)", type: "number" },
      { key: "monthly_fee", label: "Monthly Fee (₹, AI-Computer only)", type: "number" },
      { key: "actual_fee", label: "Total Investment (₹, AI-Computer only)", type: "number" },
      { key: "discounted_fee", label: "Discounted Fee (₹, optional)", type: "number" },
      { key: "offer_expires_at", label: "Offer Expiry", type: "date" },
      { key: "order", label: "Display Order", type: "number" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  testimonials: {
    label: "Testimonials",
    addLabel: "Add Testimonial",
    list: (i) => ({ title: i.name, subtitle: i.role, image: i.photo, published: i.published }),
    fields: [
      { key: "name", label: "Name *", type: "text", required: true },
      { key: "role", label: "Role / Course *", type: "text", required: true },
      { key: "quote", label: "Quote *", type: "textarea", required: true },
      { key: "photo", label: "Photo", type: "image" },
      { key: "order", label: "Display Order", type: "number" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  stories: {
    label: "Success Stories",
    addLabel: "Add Success Story",
    list: (i) => ({
      title: i.student_name,
      subtitle: `${i.course} → ${i.company}`,
      image: i.photo,
      badges: [i.year, i.position].filter(Boolean),
      published: i.published,
    }),
    fields: [
      { key: "student_name", label: "Student Name *", type: "text", required: true },
      { key: "photo", label: "Photo", type: "image" },
      { key: "course", label: "TASSEI Course *", type: "text", required: true },
      { key: "company", label: "Placed at *", type: "text", required: true },
      { key: "position", label: "Position", type: "text" },
      { key: "year", label: "Year", type: "text", placeholder: "e.g. 2025" },
      { key: "story", label: "Story", type: "textarea" },
      { key: "order", label: "Display Order", type: "number" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  offers: {
    label: "Running Offers",
    addLabel: "Add Offer",
    list: (i) => ({
      title: i.title, subtitle: i.description?.slice(0, 80),
      image: i.image, published: i.active,
      badges: i.valid_until ? [`Till ${i.valid_until}`] : [],
    }),
    fields: [
      { key: "title", label: "Offer Title *", type: "text", required: true },
      { key: "image", label: "Banner Image", type: "image" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "valid_until", label: "Valid Until", type: "date" },
      { key: "link", label: "CTA Link (WhatsApp / URL)", type: "text" },
      { key: "order", label: "Display Order", type: "number" },
      { key: "active", label: "Active (live on site)", type: "switch", default: true },
    ],
  },
  events: {
    label: "Events & Celebrations",
    addLabel: "Add Event",
    list: (i) => ({
      title: i.title, subtitle: i.description?.slice(0, 80),
      image: i.image, published: i.published,
      badges: [i.date, i.type].filter(Boolean),
    }),
    fields: [
      { key: "title", label: "Event Title *", type: "text", required: true },
      { key: "date", label: "Date *", type: "date", required: true },
      { key: "image", label: "Event Image", type: "image" },
      { key: "description", label: "Description", type: "textarea" },
      {
        key: "type", label: "Type *", type: "select", required: true,
        options: [
          { value: "upcoming", label: "Upcoming" },
          { value: "past", label: "Past" },
          { value: "celebration", label: "Celebration" },
        ],
      },
      { key: "order", label: "Display Order", type: "number" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
  holidays: {
    label: "Holiday Calendar",
    addLabel: "Add Holiday",
    list: (i) => ({
      title: i.name, subtitle: i.description, badges: [i.date], published: i.published,
    }),
    fields: [
      { key: "date", label: "Date *", type: "date", required: true },
      { key: "name", label: "Holiday Name *", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea" },
      { key: "published", label: "Published", type: "switch", default: true },
    ],
  },
};
